import { Component } from '@angular/core';

@Component({
  selector: 'mprd-skeleton-internet-option-details',
  templateUrl: './skeleton-internet-option-details.component.html',
})
export class SkeletonInternetOptionDetailsComponent {
  constructor() {}
}
